import { useEffect } from "react";
import axios from "axios";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { MemberAuthProvider } from "@/context/MemberAuthContext";
import Landing from "@/pages/Landing";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import ContactPage from "@/pages/Contact";
import Start from "@/pages/Start";
import Gallery from "@/pages/Gallery";
import Newsletter from "@/pages/Newsletter";
import NewsletterIssue from "@/pages/NewsletterIssue";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import Welcome from "@/pages/Welcome";
import Library from "@/pages/Library";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCoupons from "@/pages/AdminCoupons";
import AdminGallery from "@/pages/AdminGallery";
import AdminNewsletter from "@/pages/AdminNewsletter";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      requestAnimationFrame(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
      return;
    }
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    });
  }, [pathname, hash]);
  return null;
};

const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (navigator.doNotTrack === "1") return;
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
        path: pathname,
        ref: document.referrer || "",
      })
      .catch(() => {});
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MemberAuthProvider>
            <ScrollManager />
            <PageTracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/start" element={<Start />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/newsletter/:slug" element={<NewsletterIssue />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/account" element={<Account />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/library" element={<Library />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/coupons" element={<ProtectedRoute><AdminCoupons /></ProtectedRoute>} />
              <Route path="/admin/gallery" element={<ProtectedRoute><AdminGallery /></ProtectedRoute>} />
              <Route path="/admin/newsletter" element={<ProtectedRoute><AdminNewsletter /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </MemberAuthProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
